<template>
<list-nav :tabItems="tabItems"
          :active="active"
          :showSearch="false"
          :keyword.sync="keywordValue"
          v-on:active="onNavItemClick"
          v-on:enter="onEnterPressed" />
</template>

<script>
import ListNav from '@/components/general/list-nav'
export default {
  name: 'ReferralsNav',
  components: { ListNav },
  props: {
    active: {
      type: String,
      default: 'all'
    },
    keyword: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      tabItems: ['all'],
      filter: null
    }
  },
  computed: {
    keywordValue: {
      get () { return this.keyword },
      set (value) { this.$emit('update:keyword', value) }
    }
  },
  methods: {
    onNavItemClick (item) {
      this.$emit('active', item)
    },
    onEnterPressed () {
      this.$emit('enter')
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/referrals/referrals-nav.vue